// One ResizeObserver for every element whose height the app follows. It
// reports only real size changes, with the size the browser already has, so
// nothing has to measure the layout again.
const callbacks = new Map()
let observer = null

const borderBoxHeight = (entry) =>
  entry.borderBoxSize?.[0]?.blockSize ??
  entry.target.getBoundingClientRect().height

// calls onHeight(px) now and after each change; returns a stop function.
// One callback per element: a second call for the same element replaces it.
export const observeHeight = (element, onHeight) => {
  observer ??= new ResizeObserver((entries) => {
    for (const entry of entries) {
      callbacks.get(entry.target)?.(borderBoxHeight(entry))
    }
  })
  callbacks.set(element, onHeight)
  observer.observe(element, { box: 'border-box' })
  return () => {
    observer.unobserve(element)
    callbacks.delete(element)
  }
}
